import { defineStore } from 'pinia';

export const draftVisionStore = defineStore('draftVision', {
    state: () => ({
        idv: false,
        ilv: true,
        cdv: false,
        ctp: '章节目录',
        vmd: 'list'
    }),
    actions: {
        setCurrentVision(idv, ilv, cdv, ctp, vmd) {
            this.idv = idv;
            this.ilv = ilv;
            this.cdv = cdv;
            this.ctp = ctp;
            this.vmd = vmd;
        }
    },
    getters: {
        currentVision: (state) => ({
            idv: state.idv,
            ilv: state.ilv,
            cdv: state.cdv,
            ctp: state.ctp,
            vmd: state.vmd
        })
    }
});